// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OxIZ9","textarea":"styles_textarea__3Wwy9"};